<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useDeviceAuthStore } from '@Stores/deviceAuth.store';
import { ErrorScreenLayout, SupportEmailLink } from '@Shared';
import BrowserError from '@Assets/images/browser_error.svg';
import AuthErrorShell from '@Components/AuthErrorShell.vue';

const deviceAuthStore = useDeviceAuthStore();
const { isVerifying, error } = storeToRefs(deviceAuthStore);
</script>

<template>
    <app-page-loader v-if="isVerifying" />
    <auth-error-shell v-else-if="error" class="device-verification-view">
        <div class="device-verification-view__content">
            <error-screen-layout
                :image="BrowserError"
                image-alt="Verification error"
                title="Something went wrong"
                image-width="12rem"
                image-height="10rem">
                <p>
                    We encountered an issue while verifying your device.
                </p>
                <p>
                    If you have any questions, please reach out to <support-email-link />
                </p>
            </error-screen-layout>
        </div>
    </auth-error-shell>
    <app-page-loader v-else />
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.device-verification-view {
    @include desktop {
        padding-top: 4rem;
    }

    @include tablet-and-down {
        padding-top: 8rem;
    }

    &__content {
        border-radius: 0.25rem;
        background-color: $white;
        max-width: 30rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        line-height: 150%;
        color: $black-high;
    }
}
</style>
